import React from "react";
import RequestQuoteIcon from "@mui/icons-material/RequestQuote";
import ShoppingCartCheckoutIcon from "@mui/icons-material/ShoppingCartCheckout";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";

const TYPE_OPTIONS = [
  {
    value: "quote",
    label: "Quote",
    Icon: RequestQuoteIcon,
    selectedClasses: "border-sky-500 bg-sky-500/10 ring-1 ring-sky-500",
    iconClasses: "text-sky-500",
  },
  {
    value: "order",
    label: "Order",
    Icon: ShoppingCartCheckoutIcon,
    selectedClasses:
      "border-emerald-500 bg-emerald-500/10 ring-1 ring-emerald-500",
    iconClasses: "text-emerald-500",
  },
];

/*
  Step 2 — quote vs. order.

  Margin used to live here too, but it's internal-only and this step is often
  on screen with the customer present, so it moved into the summary bar's
  Margin chip where it stays concealed until deliberately opened.
*/
const FormTypeStep = ({ formData, setFormData }) => {
  const formType = formData.form_type || "quote";

  return (
    <div>
      <p className="mb-2 text-sm font-semibold">What are you building?</p>
      <div className="grid gap-3 sm:grid-cols-2">
        {TYPE_OPTIONS.map((option) => {
          const selected = formType === option.value;
          const { Icon } = option;
          return (
            <button
              key={option.value}
              type="button"
              aria-pressed={selected}
              onClick={() =>
                setFormData((prev) => ({ ...prev, form_type: option.value }))
              }
              className={`app-card flex min-h-[3.25rem] items-center gap-2.5 rounded-xl border px-4 py-3 text-left transition focus:outline-none focus-visible:ring-2 focus-visible:ring-sky-500 ${
                selected
                  ? option.selectedClasses
                  : "hover:border-sky-500/60"
              }`}
            >
              <Icon
                className={`shrink-0 ${
                  selected ? option.iconClasses : "app-muted"
                }`}
                sx={{ fontSize: 22 }}
              />
              <span className="text-sm font-bold">{option.label}</span>
              {selected && (
                <CheckCircleIcon
                  className={`ml-auto shrink-0 ${option.iconClasses}`}
                  sx={{ fontSize: 16 }}
                />
              )}
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default FormTypeStep;
